export * from './Cache';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-cache/lib/types/index.js
// module id = 297
// module chunks = 0